type Campo = HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement;

export function init(form: HTMLFormElement): void {
    form.querySelectorAll<Campo>('[required]').forEach(campo => {
        campo.addEventListener('blur', () => _validarCampo(campo));

        if (campo.tagName === 'SELECT') {
            campo.addEventListener('change', () => _validarCampo(campo));
        }
    });
}

export function validar(form: HTMLFormElement): boolean {
    let valido = true;

    form.querySelectorAll<Campo>('[required]').forEach(campo => {
        if (!_validarCampo(campo)) valido = false;
    });

    return valido;
}

function _validarCampo(campo: Campo): boolean {
    const vazio = campo.value.trim() === '';

    if (vazio) {
        _setInvalido(campo);
        return false;
    }

    _setValido(campo);
    return true;
}

function _setInvalido(campo: Campo): void {
    campo.classList.remove('is-valid');
    campo.classList.add('is-invalid');

    let feedback = _getFeedback(campo);
    if (!feedback) {
        feedback = document.createElement('div');
        feedback.className = 'invalid-feedback validation-feedback';
        campo.parentElement?.appendChild(feedback);
    }

    feedback.textContent = campo.dataset.mensagem ?? _getLabelTexto(campo) ?? 'Campo obrigatório.';
}

function _setValido(campo: Campo): void {
    campo.classList.remove('is-invalid');
    campo.classList.add('is-valid');

    const feedback = _getFeedback(campo);
    if (feedback) feedback.textContent = '';
}

function _getFeedback(campo: Campo): HTMLElement | null {
    return campo.parentElement?.querySelector('.validation-feedback') ?? null;
}

function _getLabelTexto(campo: Campo): string | null {
    if (!campo.id) return null;
    const label = document.querySelector<HTMLLabelElement>(`label[for="${campo.id}"]`);
    if (!label) return null;

    // Pega só o texto do label, ignorando elementos filhos (ex: span com *)
    const texto = Array.from(label.childNodes)
        .filter(n => n.nodeType === Node.TEXT_NODE)
        .map(n => n.textContent?.trim())
        .find(t => t);

    return texto ? `${texto} é obrigatório.` : null;
}
